import { oc } from '@orpc/contract';
import { commitImportOutputSchema, importUploadInputSchema } from '../schemas/import.schemas.js';
export const commitImportContract = oc
    .route({
    method: 'POST',
    path: '/import/commit',
    tags: ['Import'],
    summary: 'Import every acceptable row of a filled-in template as a test run',
    description: 'Takes the same file payload as `preview` and re-parses it: the server keeps no state between the two calls, so the verdicts a commit acts on are always computed from the bytes in hand. Each accepted row is entered through the ordinary run path (createDraft → updateConditions → updateMeasurements → submit) attributed to the uploader, with `source = IMPORT` and the batch id recorded. Rows are independent — one failure is a rejection in the error report, not an aborted batch.',
})
    .input(importUploadInputSchema)
    .output(commitImportOutputSchema);
//# sourceMappingURL=commit-import.contract.js.map